<template>
  <div>
    <div style="text-align: center" v-if="!itmes || itmes.length === 0">
      <img src="/image/static/img/nodata.png" />
      <p class="no-data">暂无子线路信息！</p>
    </div>
    <el-timeline>
      <el-timeline-item
        v-for="(itme, index) in itmes"
        :key="index"
        type="primary"
      >
        <el-form :disabled="true">
          <el-row>
            <el-col :span="12">
              <el-tag
                type="success"
                class="mr-2"
                v-if="itme.stepScheduleType"
                >{{ itme.stepScheduleType }}</el-tag
              >
            </el-col>
            <el-col :span="12">
              <b-button-group v-if="isDisableEditForm">
                <b-button
                  class="mr-2"
                  size="sm"
                  title="编辑"
                  variant="outline-secondary"
                  @click="
                    $emit('openDetailEditFrom', {
                      type: 'edit',
                      code: itme.transferRuleDetailCode,
                    })
                  "
                >
                  <b-icon-pencil></b-icon-pencil>
                </b-button>
                <b-button
                  v-b-tooltip.hover
                  class="mr-2"
                  title="删除"
                  @click="del(itme.transferRuleDetailCode)"
                  variant="outline-secondary"
                  size="sm"
                >
                  <b-icon-trash-fill></b-icon-trash-fill>
                </b-button>
              </b-button-group>
            </el-col>
          </el-row>
          <el-row v-if="itme.stepScheduleType === '时间节点方式'">
            子单计划送达时间：计划提货后第：
            <el-tag type="warning" class="mr-2" v-if="itme.stepReceivingDay">{{
              itme.stepReceivingDay
            }}</el-tag
            >天
            <el-tag
              type="warning"
              class="mr-2 ml-2"
              v-if="itme.stepReceivingHour"
              >{{ itme.stepReceivingHour }}</el-tag
            >时
            <el-tag
              type="warning"
              class="mr-2 ml-2"
              v-if="itme.stepReceivingMinute"
              >{{ itme.stepReceivingMinute }}</el-tag
            >分 送达
          </el-row>
          <el-row class="mt-1" v-if="itme.stepScheduleType === '时间节点方式'">
            子单计划提货时间：计划提货后第：
            <el-tag type="warning" class="mr-2" v-if="itme.nextStepPickUpDay">{{
              itme.nextStepPickUpDay
            }}</el-tag
            >天
            <el-tag
              type="warning"
              class="mr-2 ml-2"
              v-if="itme.nextStepPickUpHour"
              >{{ itme.nextStepPickUpHour }}</el-tag
            >时
            <el-tag
              v-if="itme.nextStepPickUpMinute"
              type="warning"
              class="mr-2 ml-2"
              >{{ itme.nextStepPickUpMinute }}</el-tag
            >分 提货
          </el-row>

          <el-row v-if="itme.stepScheduleType === '默认时效方式'">
            子单时效要求：
            <el-tag type="warning" class="mr-2">{{
              itme.stepTransportHours
            }}</el-tag>
            小时
          </el-row>
          <el-row class="mt-1" v-if="itme.stepScheduleType === '默认时效方式'">
            子单中转站停留时效：
            <el-tag type="warning" class="mr-2">{{
              itme.stepWaitingHours
            }}</el-tag>
            小时
          </el-row>

          <el-row class="mt-1">
            子单组织结构：
            <el-tag v-if="itme.stepOrgName">{{ itme.stepOrgName }}</el-tag>
          </el-row>

          <el-row class="mt-1">
            子单业务类型：
            <el-tag v-if="itme.stepBusinessType">{{
              itme.stepBusinessType
            }}</el-tag>
          </el-row>
          <el-row class="mt-1">
            中转站：<el-tag v-if="itme.transferStationName">{{
              itme.transferStationName
            }}</el-tag>
          </el-row>
        </el-form>
      </el-timeline-item>
    </el-timeline>
  </div>
</template>
<script>
export default {
  props: {
    code: String,
    isDisableEditForm: { type: Boolean, default: () => true },
  },
  data() {
    return {
      itmes: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    reload(code) {
      this.code = code
      this.getData()
    },
    getData() {
      if (!this.code) {
        return
      }
      return this.$api
        .masterTransferRuleDetailDetailListApi({
          transferRuleCode: this.code,
        })
        .then((res) => {
          this.itmes = res.body.data
        })
    },
    del(code) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api
          .masterTransferRuleDetailDelApi({ transferRuleDetailCode: code })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.getData()
          })
      })
    },
  },
}
</script>
